import Api from '@/services/api'

// Employee-facing Forms API (behind the authenticated /user routes). The shared
// api.js factory attaches the Bearer token and handles 403 session expiry.
export default {
  // List the forms this employee can fill (server returns only 'active' forms).
  list () {
    return Api().get('user/forms')
  },

  // Fetch one form's definition for rendering (vehicle options are live).
  get (slug) {
    return Api().get(`user/forms/${encodeURIComponent(slug)}`)
  },

  // Submit a filled-in form. payload: { answers, idempotencyKey }.
  submit (slug, payload) {
    return Api().post(`user/forms/${encodeURIComponent(slug)}/submissions`, payload)
  },
}
